/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import NotableInfo from "reusables/TextFormats/NotableInfo";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";
import Email from "reusables/Contact/Email";

// Images

function Quality_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title=""
            contents={
              <>
                At Spechs Property Services, we are committed to providing exceptional cleaning and
                management solutions. Our Quality Policy reflects our unwavering dedication to
                delivering top-tier, reliable, and professional services tailored to the unique
                needs of each client.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Client-Centric Approach"
            contents={
              <>
                We prioritise our clients’ business needs and requirements above all else.
                Recognising the importance of a clean and well-maintained workspace, we ustomize our
                services to ensure your business environment remains immaculate and inviting. Our
                aim is to exceed your expectations, giving you confidence that your office space
                will always leave a positive impression on both clients and employees.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Consistent and Dependable Services"
            contents={
              <>
                We understand that consistency is vital to maintaining the professionalism of your
                business. Our team of skilled professionals undergoes comprehensive training to
                deliver reliable results every time. With meticulous attention to detail and a
                commitment to excellence, we ensure your property consistently meets the highest
                standards of cleanliness.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Environmental Responsibility"
            contents={
              <>
                As an environmentally conscious company, we are committed to using sustainable and
                eco-friendly products and practices. Our dedication to protecting the environment
                aligns with your values, fostering a clean and healthy space for employees and
                clients alike.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Continuous Improvement"
            contents={
              <>
                We believe in continuous growth and staying at the forefront of our industry.
                Through regular evaluations and feedback from our clients, we refine our processes
                to maximise efficiency and effectiveness. By embracing innovation and best
                practices, we strive to provide services that are second to none.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Team Excellence"
            contents={
              <>
                Our success stems from the expertise and dedication of our team. We cultivate a
                culture of excellence, encouraging our staff to take pride in their work and deliver
                outstanding services with integrity and professionalism.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Safety and Security"
            contents={
              <>
                The safety and security of your business premises are our highest priorities. Our
                team strictly adheres to established safety protocols, ensuring a secure environment
                during all operations. We are committed to safeguarding your business assets and the
                well-being of your personnel at all times.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Our Goal as a Business"
            contents={
              <>
                Our ultimate goal is to provide business owners like you with peace of mind and the
                freedom to focus on your core activities. By entrusting us with the responsibility
                of maintaining your workspace, you can be assured that your office will consistently
                reflect professionalism and excellence. At Spechs Property Services, we value your
                time and aim to create a conducive environment that supports your growth and
                success.
              </>
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Quality_Section1;
